import { render, staticRenderFns } from "./GoogleDialog.vue?vue&type=template&id=b5f471d4&"
import script from "./GoogleDialog.vue?vue&type=script&lang=js&"
export * from "./GoogleDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoogleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports